<template>
  <div class="serve">
    <router-view></router-view>
  </div>
</template>

<script>
    export default {
        name: "serve"
    }
</script>

<style scoped>

</style>
